import Hirers from '@/api/hirers'

export default {
  namespaced: true,
  state: {
    firstName: null,
    lastName: null,
    email: null,
    company: [],
    role: 'hirer',
    accountId: null
  },
  getters: {
    formData: state => {
      return {
        firstName: state.firstName,
        lastName: state.lastName,
        email: state.email,
        company: state.company.map(item => item.id),
        accountId: state.accountId
      }
    }
  },
  mutations: {
    setFirstName (state, firstName) {
      state.firstName = firstName
    },
    setLastName (state, lastName) {
      state.lastName = lastName
    },
    setEmail (state, email) {
      state.email = email
    },
    setCompany (state, company) {
      state.company = company
    },
    setRole (state, role) {
      state.role = role
    },
    setHirer (state, hirer) {
      state.firstName = hirer.firstName
      state.lastName = hirer.lastName
      state.email = hirer.email
      state.company = hirer.companies[0] === null ? null : hirer.companies
      state.accountId = hirer.accountId
    },
    clear (state) {
      state.firstName = null
      state.lastName = null
      state.email = null
      state.company = []
      state.role = 'hirer'
      state.accountId = null
    }
  },
  actions: {
    async registerHirer ({ commit, getters }) {
      const data = getters.formData
      const hirer = await Hirers.register(data)
      commit('adminHirers/addHirer', hirer, { root: true })
    },
    async updateHirer ({ getters }) {
      const data = getters.formData
      await Hirers.update(data)
    },
    async attachHirer ({ commit }, companyId) {
      await Hirers.attach({'companyId': companyId})
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hirer-form.js